import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  IconBuildingBank,
  IconChevronLeft,
  IconCoins,
  IconHourglassHigh,
  IconReceiptRefund,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";
import { ROUTES } from "../../constants/routes";

const SetupPayoutAccount = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(ROUTES.EARNINGS);
  };

  const handleGetStarted = () => {
    navigate(ROUTES.PAYOUT_GETTING_STARTED);
  };

  const features = [
    {
      icon: <IconCoins size={24} />,
      title: "Players pay to join",
      description:
        "You can create games and we'll handle the rest so you can get on with the game.",
    },
    {
      icon: <IconBuildingBank size={24} />,
      title: "Quick payouts",
      description: "Money from your bank 24 hours after the game is finished.",
    },
    {
      icon: <IconReceiptRefund size={24} />,
      title: "Hassle free refunds",
      description:
        "Player cancellations 24 hours before will be automatically refunded in credits.",
    },
    {
      icon: <IconHourglassHigh size={24} />,
      title: "Reduce no-shows",
      description:
        "Player deposits are held for 24 hours before the game to reduce no-shows.",
    },
  ];

  return (
    <>
      {/* Back Button */}
      <Box sx={{ mb: 3, display: { xs: "block", md: "none" } }}>
        <Button variant="back" onClick={handleBack} />
      </Box>

      <Box
        sx={{
          flex: { xs: "none", md: 1 },
          backgroundColor: { xs: "transparent", md: "white" },
          borderRadius: { xs: 0, md: "8px" },
          boxShadow: { xs: "none", md: "0 2px 8px rgba(0,0,0,0.1)" },
          p: { xs: 0, md: 3 },
        }}
      >
        {/* Page Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "center", md: "flex-start" },
            gap: 1,
            mb: 3,
          }}
        >
          <Box
            onClick={handleBack}
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              cursor: "pointer",
              color: "#1890FF",
              "&:hover": {
                color: "#40A9FF",
              },
            }}
          >
            <IconChevronLeft size={20} />
          </Box>
          <Text variant="pageHeader">Set up payout account</Text>
        </Box>

        {/* Description */}
        <Text
          component="p"
          variant="paragraph"
          sx={{
            color: "#666",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          Collect payments for games you create for hassle free game and player
          management.
        </Text>

        {/* Features List */}
        <List sx={{ p: 0, mb: "32px" }}>
          {features.map((feature, index) => (
            <ListItem
              key={index}
              sx={{
                px: 0,
                py: "16px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ListItemIcon
                sx={{
                  color: "black",
                  minWidth: "0px",
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  background: " #F5F5F5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {feature.icon}
              </ListItemIcon>
              <ListItemText
                primary={feature.title}
                secondary={feature.description}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#000",
                  },
                  "& .MuiListItemText-secondary": {
                    fontWeight: 400,
                    color: "#666",
                    lineHeight: "1.4",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Button
            component="a"
            href="https://slow-centipede-6ab.notion.site/How-payments-work-on-Findaside-2843273d40638042b99fd11353831436"
            target="_blank"
            rel="noopener noreferrer"
            variant="link"
            sx={{
              color: "#1890FF",
              fontSize: "16px",
              p: 0,
              alignSelf: "center",
            }}
          >
            Learn more
          </Button>

          <Button
            variant="primary"
            onClick={handleGetStarted}
            sx={{ width: "100%" }}
          >
            Get started
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default SetupPayoutAccount;
